import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class ShipmentStatusCount extends Model {

  @Expose() totalCount: number;
  @Expose() totalNewStatusCount: number;
  @Expose() totalOrderPlacedStatusCount: number;
  @Expose() totalAcceptedStatusCount: number;
  @Expose() totalAssignedStatusCount: number;
  @Expose() totalDriverAcceptedStatusCount: number;
  @Expose() totalInTransitStatusCount: number;
  @Expose() totalArrivePickupLocationStatusCount: number;
  @Expose() totalGoodsLoadedStatusCount: number;
  @Expose() totalArriveDropOffLocationStatusCount: number;
  @Expose() totalGoodsDeliveredStatusCount: number;
  @Expose() totalReturnedStatusCount: number;
  @Expose() totalRejectedStatusCount: number;
  @Expose() totalIncompleteStatusCount: number;
  @Expose() totalCanceledStatusCount: number;
  @Expose() totalNotFulfilledStatusCount: number;


  constructor() {
    super();
  }
}
